import { useCallback } from 'react';

import { useQuery } from '@apollo/client/react';
import { ListItem } from '@mui/material';

import { GET_PROPERTY_TYPES } from '@modules/_shared/common/queries';
import type { filterAutocompleteRenderOptionProps } from '@modules/_shared/components/filters/quick-filters/QuickFilters';

export const usePropertyTypeOptionRenderer = () => {
  const { data: propertyTypesData } = useQuery(GET_PROPERTY_TYPES);

  return useCallback<filterAutocompleteRenderOptionProps>(
    (props, option) => {
      const propertyType = propertyTypesData?.property_types?.find(
        pt => pt.name === option.value,
      );
      const displayLabel = propertyType?.label || option.label;

      return (
        <ListItem {...props} key={`property-type-${option.value}`}>
          {displayLabel}
        </ListItem>
      );
    },
    [propertyTypesData],
  );
};
